import { AdaChatConfig, SupportChatbot } from "../types";
import { getIsMinimized } from "../store/supportChatSelectors";
import {
  endChatSession,
  setActiveSupportType,
  setChatFabVisible,
  toggleChatWindow,
} from "../store/supportChatReducer";
import { AnyAction, Dispatch } from "redux";
import { SelfServeState } from "../store";
import { SupportType } from "@b2bportal/chat-api";

export class HTSAssistSupportChatbot implements SupportChatbot {
  private dispatch: Dispatch<AnyAction>;
  private getState: () => SelfServeState;

  constructor(dispatch: Dispatch<AnyAction>, getState: () => SelfServeState) {
    this.dispatch = dispatch;
    this.getState = getState;
  }

  get isInitialized(): boolean {
    return true;
  }

  initialize = (config?: AdaChatConfig, onLoad?: () => void): void => {
    onLoad && onLoad();
  };

  toggleSupportChatbot = async (): Promise<void> => {
    this.dispatch(toggleChatWindow());
  };

  openSupportChatbot = async (): Promise<void> => {
    const isMinimized = getIsMinimized(this.getState());

    if (isMinimized) {
      this.dispatch(toggleChatWindow());
    }
  };

  minimizeSupportChatbot = async (): Promise<void> => {
    const isMinimized = getIsMinimized(this.getState());
    if (!isMinimized) {
      this.dispatch(toggleChatWindow());
    }
  };

  startNewChat = async (supportType?: SupportType): Promise<void> => {
    this.dispatch(endChatSession());
    this.dispatch(setActiveSupportType(supportType));
    await this.openSupportChatbot();
  };

  isChatbotOpen = async (): Promise<boolean> => {
    return !getIsMinimized(this.getState());
  };

  toggleSupportChatbotButton = (showButton: boolean): void => {
    this.dispatch(setChatFabVisible(showButton));
  };
}
